import { ISiteUserInfo } from '../../userManagement/users/models/ISiteUserInfo';
import React = require('react');
import { Formik, FormikProps } from 'formik';

import { Messages } from '../../codegen/Localize';
import { FormikCheckbox } from '../../commonInfra/components/FormikCheckbox';
import { UserSettingsStyle } from '../styles/UserSettingsStyle';
import _ = require('underscore');

import { ToasterService, ToastType } from '~commonInfra/services/ToasterService';
import { beaconComponentRegistryEntry, getUserAccountSettingsURL } from '~src/beacon/BeaconComponentRegistryFunctions';
import { DeepLink } from '~src/beacon/deepLink/DeepLink';

import { IError } from '../../httpClient/serverApi/types/IError';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { IServerUserInfo } from '../../userManagement/users/models/IServerUserInfo';
import { UserSettings } from '../services/resources/UserSettings';
import { InlineCancelAndSaveButtons } from './UserSettingEditButtons';

const DEEPLINK_ID = 'animations';

export type MarkAnimationProps = {
    userHasNoSiteId: boolean;
    siteUser: ISiteUserInfo;
    serverUser: IServerUserInfo;
}

export interface MarkAnimationField {
    markAnimationSetting: boolean;
}

export const MarkAnimationSectionTestId: string = 'userSettings-mark-animation';
export const MarkAnimationCheckBoxTestId: string = 'Mark-Animation-Enabled';

function showButtons(formik: FormikProps<MarkAnimationField>, markAnimationSetting: boolean) {
  if (!formik.touched || !formik.isValid || formik.isSubmitting || _.isEqual(formik.values.markAnimationSetting, markAnimationSetting)) {
    return false;
  }
  return true;
}

export function MarkAnimationSetting(props: MarkAnimationProps): JSX.Element {
  const [currentMarkAnimation, setCurrentMarkAnimation] = React.useState(false);

  function handleSubmit(values: MarkAnimationField, siteUser: ISiteUserInfo) {
    UserSettings.updateMarkAnimationSetting(
      siteUser.id, values.markAnimationSetting
    ).then((result: IResult) => {
      setCurrentMarkAnimation(values.markAnimationSetting);
      ToasterService.instance.pop({ type: ToastType.Success, text: Messages.settingsUpdateSuccess() });
    }).catch((error: IError) => {
      ToasterService.instance.pop({ type: ToastType.Error, text: Messages.settingsUpdateFailure() });
    });
  }

  React.useEffect(
    () => {
      UserSettings.getMarkAnimationSetting(props.serverUser.id)
      .then((result: boolean) => {
        setCurrentMarkAnimation(result);
      }).catch((error: IError) => { });
    },
    [props.serverUser.id]
  );

  return (
    <Formik
      initialValues={{ markAnimationSetting: currentMarkAnimation }}
      onSubmit={(values: MarkAnimationField) => handleSubmit(values, props.siteUser)}
      enableReinitialize={true}
    >
      {
        (formik: FormikProps<MarkAnimationField>) => (
          <DeepLink deepLinkId={DEEPLINK_ID}>
            <form onSubmit={formik.handleSubmit}>
              <table>
                <tbody className={UserSettingsStyle.tbody}>
                  <tr data-tb-test-id={MarkAnimationSectionTestId}>
                    <td className={UserSettingsStyle.labelText}>
                      {Messages.markAnimationSettingSection()}</td>
                    <td className={UserSettingsStyle.detailsValue}>
                      {Messages.markAnimationUserSettingDetail()}</td>
                  </tr>
                  <tr>
                  <td className={UserSettingsStyle.labelText}></td>
                  <td className={UserSettingsStyle.detailsValue}>
                    <FormikCheckbox
                    containerStyle={{marginLeft: 0}}
                    testId={MarkAnimationCheckBoxTestId}
                    name='markAnimationSetting'
                    disabled={props.userHasNoSiteId}
                    label={Messages.markAnimationUserSettingEnable()}/>
                  </td>
                  </tr>
                  {
                    showButtons(formik, currentMarkAnimation) &&
                    <InlineCancelAndSaveButtons
                    testId='Mark-Animation'
                    formik={formik}
                    />
                  }
                 </tbody>
              </table>
            </form>
          </DeepLink>
        )
      }
    </Formik>
  );
}

export const AnimationSettingBeaconConfig = beaconComponentRegistryEntry({
  command: () =>  Messages.markAnimationSettingSection(),
  deeplinkId: DEEPLINK_ID,
  url: (props) => getUserAccountSettingsURL(props.sessionInfo),
  isAdmin: false,
  tags: () => [ Messages.markAnimationUserSettingDetail(), Messages.userSettings_Preference_Header() ]
});